import { Background, style } from '@do/walrus';
import React, { ReactElement } from 'react';
import defaultBg from '../assets/backgrounds/HeroBackground-Option1-01.png';
import { DynamicVariantProps } from '../interfaces/variant';
import { Column, Row } from './Common';
import { DynamicSplash } from './DynamicSplash';

interface Props {
  variant: DynamicVariantProps;
}

export const DynamicVariant: React.FC<Props> = ({
  children,
  variant
}): ReactElement => {
  return variant?.splash ? (
    <Row>
      <Column
        style={{
          background: style.colors.grey.lightest
        }}
      >
        {children}
      </Column>
      <DynamicSplash splash={variant.splash} variantType={variant.type} />
    </Row>
  ) : (
    <>
      <Background url={defaultBg} />
      {children}
    </>
  );
};
